import React from "react";
import Input from "./Input";
import { Controller } from "react-hook-form";
import CustomSelect from "./CustomSelect";

const BookingCards = ({
  title,
  value,
  count,
  register,
  control,
  cardIndex,
  errors,
}) => {
  const options = [
    { value: "male", label: "Male", color: "#3498db" },
    { value: "female", label: "Female", color: "#e74c3c" },
    { value: "other", label: "Other", color: "#2ecc71" },
  ];
  return (
    <div className="w-full min-h-[270px] pt-[20px] pb-[16px] px-[10px] xs:px-[16px] bg-white rounded-[10px] mb-[20px]">
      <div className="flex items-center justify-between pb-[20px] border-b border-b-[#C1CAE1]">
        <h1
          className={`${
            title === "Economical" ? "text-[#7020FF]" : "text-[#F8B34B]"
          } font-semibold text-base`}
        >
          {title} x {count}
        </h1>
        <h3 className="text-black text-sm">AED {value}</h3>
      </div>

      <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 mt-[20px] gap-[16px]">
        <div>
          <Input
            {...register(`guestDetails[${cardIndex}].fullName`)}
            label={"Full name"}
            placeholder={"Enter full name"}
            inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] placeholder:text-[#06152B] text-[#06152B]"
            lableClasses="text-sm  text-[#06152B]"
          />
          {errors.guestDetails?.[cardIndex]?.fullName && (
            <p className="text-red-500 text-sm">
              {errors.guestDetails[cardIndex].fullName.message}
            </p>
          )}
        </div>

        <div>
          <Input
            label={"Mobile Number"}
            {...register(`guestDetails[${cardIndex}].mobileNumber`)}
            placeholder={"Mobile number"}
            inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] placeholder:text-[#06152B] text-[#06152B]"
            lableClasses="text-sm text-[#06152B]"
          />
          {errors.guestDetails?.[cardIndex]?.mobileNumber && (
            <p className="text-red-500 text-sm">
              {errors.guestDetails[cardIndex].mobileNumber.message}
            </p>
          )}
        </div>

        <div>
          <Input
            label={"Email id"}
            placeholder={"Enter email id"}
            {...register(`guestDetails[${cardIndex}].email`)}
            type="email"
            inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] placeholder:text-[#06152B] text-[#06152B]"
            lableClasses="text-sm  text-[#06152B]"
          />
          {errors.guestDetails?.[cardIndex]?.email && (
            <p className="text-red-500 text-sm">
              {errors.guestDetails[cardIndex].email.message}
            </p>
          )}
        </div>

        <div>
          <label className={`mb-2 text-sm  font-medium text-[#06152B] `}>
            Gender
          </label>
          <Controller
            name={`guestDetails[${cardIndex}].gender`}
            control={control}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <CustomSelect
                options={options}
                onChange={onChange}
                value={value}
                onBlur={onBlur}
                ref={ref}
              />
            )}
          />
          {errors.guestDetails?.[cardIndex]?.gender && (
            <p className="text-red-500 text-sm">
              {errors.guestDetails[cardIndex].gender.message}
            </p>
          )}
        </div>
        <div>
          <Input
            {...register(`guestDetails[${cardIndex}].age`)}
            label={"Age"}
            placeholder={"Enter age"}
            inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] placeholder:text-[#06152B] text-[#06152B]"
            lableClasses="text-sm  text-[#06152B]"
          />
          {errors.guestDetails?.[cardIndex]?.age && (
            <p className="text-red-500 text-sm">
              {errors.guestDetails[cardIndex].age.message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingCards;
